import { useState as r, useRef as e, useCallback as t } from "react";
const o = (o2, c = 500) => {
  const [n, u] = r(""), s = e(null);
  return [n, t((r2) => {
    u(r2), s.current && clearTimeout(s.current), c <= 0 ? o2(r2.toLowerCase()) : s.current = setTimeout(() => {
      o2(r2.toLowerCase());
    }, c);
  }, [o2, c])];
};
export {
  o as useDebounceSearchSetState
};
//# sourceMappingURL=useDebounceSearchSet.js.map
